import { createContext } from "react";

export const AuthContext = createContext({
  isLoggedIn: false,
  isModalOpened: false,
  isFilterModalOpened: false,
  isJobModalOpened: false,
  isMapModalOpened: false,
  isJobOfferOpened: false,
  isJobPopupOpened: false,
  jobProps: [],
  userId: null,
  companyId: null,
  token: null,
  login: () => { },
  logout: () => { },
  toggleModal: () => { },
  toggleFilterModal: () => { },
  toggleMapModal: () => { },
  toggleJobOfferModal: () => { },
  toggleJobPopupModal: () => { },
  toggleJobModal: () => { },
  defineJobProps: () => { }
});
